var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ddex-import mt-2"},[_c('DdexImport')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }